import { useQuery } from "@tanstack/react-query";

import { getIpInfo } from "~/services";

export const useIpInfo = () => {
  return useQuery({
    queryKey: ["ipInfo"],
    queryFn: getIpInfo,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    retry: 2,
    refetchOnWindowFocus: false,
  });
};
